import { inventoryTransactionBeforeSave } from "services/sosInventoryService/inventoryTransaction/beforeSave";
import { convertNativeToCustom } from "services/utility/customFields";

import globalState from "globalState/globalState";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const { adjustmentHasNextRefNumberSet } =
    globalState.getState().userCompanySettings.settings;

  const newRecord = inventoryTransactionBeforeSave(
    OBJECT_TYPES.ADJUSTMENT.fullString,
    record
  );

  // Remove "auto" from number field when auto-numbering is not set
  if (!adjustmentHasNextRefNumberSet && newRecord.number === "auto") {
    newRecord.number = "";
  }

  newRecord.customFields = convertNativeToCustom(record.customFields);

  return newRecord;
}
